<div class="dodo-cta-features-pointer"
     [style.height.px]="containerHeight">
	<div class="pointer"
	     [style.width.px]="pointerDiag"
	     [style.height.px]="containerHeight"
	     [style.left.px]="pointerPosition">
		<div class="content"
		     [style.width.px]="pointerSize"
			 [style.height.px]="pointerSize"
			 [style.backgroundColor] = "backgroundColor">
		</div>
		<!-- <div class="content"
		     [style.width.px]="pointerSize"
		     [style.height.px]="pointerSize"
		     [style.transform]="'rotate(45Deg) translate(' + (pointerSize / 10) * 3 + 'px)'">
		</div> -->
	</div>
</div>
